import GoogleAnalytics from './GoogleAnalytics';

class GoogleAnalyticsBaseEvents {
  static trackPageView = (): void => {
    GoogleAnalytics.track('page_view', {
      page_path: (window.location.pathname + window.location.search),
    });
  };
}

export default GoogleAnalyticsBaseEvents;
